import { useEffect } from 'react';
import { type MyOCData } from '@cx-web/domain-types/myoc';

import { ModalView, useModalContext } from '~/providers/modal-context';
import { gtmTrackingLogInClicked } from '~/utils/us-utils';

interface IProps {
  currentPath: string;
  myocData: MyOCData;
  viewToOpen: 'Login' | 'Profile' | 'Signup';
}

function defaultPanel(viewToOpen: IProps['viewToOpen'], myocData: MyOCData): string {
  switch (true) {
    case myocData?.view === 'User':
    case viewToOpen === 'Login' && !!myocData?.myOCUser:
      return 'Profile';
    case viewToOpen === 'Profile' && myocData?.view === 'Settings':
      return 'Settings';
    default:
      return viewToOpen || myocData?.view;
  }
}

export default function LegacyAuthModalTrigger({ currentPath, myocData, viewToOpen }: IProps) {
  const [, dispatch] = useModalContext();

  useEffect(() => {
    const trigger = () => {
      if (typeof window === 'undefined' || typeof window.ocAuth === 'undefined') return;

      const panel = defaultPanel(viewToOpen, myocData);

      const shouldTriggerSignupModal = !myocData?.myOCUser && panel === 'Signup';
      const shouldTriggerLoginModal = !myocData?.myOCUser && (panel === 'Login' || currentPath === 'login');

      switch (true) {
        case shouldTriggerSignupModal:
          dispatch({
            type: 'SET_VIEW',
            // @ts-ignore
            payload: { view: ModalView.SignupForm },
          });
          window.ocAuth.isNavbarSignup = true;
          break;

        case shouldTriggerLoginModal:
          gtmTrackingLogInClicked();
          dispatch({
            type: 'SET_VIEW',
            // @ts-ignore
            payload: { view: ModalView.LoginForm },
          });
          window.ocAuth.isNavbarLogin = true;
          break;

        default:
          break;
      }
    };

    if (!window.ocAuth) {
      window.addEventListener('OC:ocAuthReady', trigger);
    }
    trigger();

    return () => window.removeEventListener('OC:ocAuthReady', trigger);
  }, [viewToOpen, myocData?.view, myocData?.myOCUser]);

  return null;
}
